import { __read } from 'tslib';
import { useEffect } from 'react';
import { useLocationLiteCookie } from '../../cookie/hooks.esm.js';
import { DEFAULT_POLLING_INTERVAL, DEFAULT_MAX_POLLING_TIME } from '../constants.esm.js';
import { isOnServer } from './isOnServer.esm.js';
import { getOnCookieChange } from './onCookieChange.esm.js';
import { getPollForCookieChange } from './pollForCookieChange.esm.js';

/**
 * This hook exists to work around a limitation in react-cookie and universal-cookie
 * related to cookies that are updated by fetch/xhr requests. It should only run in the browser.
 *
 * It will poll every {pollingInterval} ms, up to a maximum duration of {maxPollingTime} ms
 *
 * Once it detects a change in the cookie we're interested in, polling is canceled and all cookie
 * handline is handed over to react-cookie
 * @see https://github.com/reactivestack/cookies/issues/304
 */
var useCookiePolling = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.pollingInterval, pollingInterval = _c === void 0 ? DEFAULT_POLLING_INTERVAL : _c, _d = _b.maxPollingTime, maxPollingTime = _d === void 0 ? DEFAULT_MAX_POLLING_TIME : _d;
    var _e = __read(useLocationLiteCookie(), 2), cookieContent = _e[0], setCookieContent = _e[1];
    useEffect(function () {
        /**
         * If we're on the server (NextJS), skip all of this
         */
        if (isOnServer()) {
            return;
        }
        /**
         * If the cookie is already set, we don't need to poll, as the server will not change it once set
         */
        if (cookieContent === null || cookieContent === void 0 ? void 0 : cookieContent.countryCode) {
            return;
        }
        var pollForCookieChanges = getPollForCookieChange({ maxPollingTime: maxPollingTime, pollingInterval: pollingInterval });
        var onCookieChange = getOnCookieChange(setCookieContent);
        var pollRepeater = pollForCookieChanges(onCookieChange);
        return function () {
            clearInterval(pollRepeater);
        };
    }, [cookieContent.countryCode, maxPollingTime, pollingInterval, setCookieContent]);
};

export { useCookiePolling };
//# sourceMappingURL=useCookiePolling.esm.js.map
